export default "__VITE_ASSET__DDWYB8c1__"